import { Button, Form } from "react-bootstrap";
import { FaChevronDown, FaFilter, FaSyncAlt } from "react-icons/fa";
import "../accountingFilters.css";

const AccountingFilterSection = ({
  title,
  open,
  onToggle,
  onSubmit,
  onReset,
  activeCount = 0,
  toolbarRight = null,
  children,
  closeOnSubmit = true,
}) => {
  const hasFilters = activeCount > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(e);
    if (closeOnSubmit && onToggle) {
      onToggle(false);
    }
  };

  return (
    <>
      <div className="acc-filter-toolbar">
        <div className="acc-filter-toolbar-left">
          {title && <h5 className="mb-0 fw-bold">{title}</h5>}
          <Button
            type="button"
            variant="primary"
            size="sm"
            className={`acc-filter-toggle ${open ? "is-open" : ""} ${hasFilters ? "has-filters" : ""}`}
            onClick={() => onToggle?.(!open)}
          >
            <FaFilter />
            Bộ lọc
            {activeCount > 0 && (
              <span className="acc-filter-badge">{activeCount}</span>
            )}
            <FaChevronDown className="acc-filter-chevron" />
          </Button>
        </div>
        {toolbarRight && (
          <div className="acc-filter-toolbar-right">{toolbarRight}</div>
        )}
      </div>

      <div className={`acc-filter-panel ${open ? "is-open" : ""}`}>
        <div className="acc-filter-panel-inner">
          <Form onSubmit={handleSubmit}>
            {children}
            <div className="acc-filter-actions">
              <Button type="submit" variant="primary" size="sm">
                <FaFilter className="me-1" />
                Lọc
              </Button>
              <Button type="button" variant="outline-secondary" size="sm" onClick={onReset}>
                <FaSyncAlt />
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AccountingFilterSection;
